import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./App.css"
import {SnackbarProvider} from "notistack";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!)
    .render( <SnackbarProvider maxSnack={3}>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </SnackbarProvider>);
